import { FormattedMessage } from 'react-intl';

import { Text, TextType } from 'ui-components/components/text';

import styles from '../styles.module.less';
import { messages } from './messages';
import { SelectPropertyDropdown } from '../widget-properties/select-property-dropdown';

import type { PageDefinition, PageModeType, PropertyOptions } from '../../config';

const pageModeItems: PropertyOptions<PageModeType> = [
  {
    key: 'blank',
    name: <FormattedMessage {...messages.blank} />,
  },
  {
    key: 'grid',
    name: <FormattedMessage {...messages.grid} />,
  },
];

type PagePropertiesProps = {
  page: PageDefinition;
  updatePage: (page: Partial<PageDefinition>) => void;
};

export const PageProperties = ({ page, updatePage }: PagePropertiesProps) => {
  return (
    <section className={styles.panel}>
      <Text className={styles['panel-header']} textType={TextType.H4} value={messages.pageProperties} />
      <div className={styles.properties}>
        <div className={styles['property-group']}>
          <Text className={styles['property-label']} element='span' textType={TextType.Paragraph} value={messages.size} />
          <span className={styles['property-input']}>{page.ui.documentSize}</span>
        </div>
        <div className={styles['property-group']}>
          <label className={styles['property-label']} htmlFor='page-mode'>
            <FormattedMessage {...messages.displayMode} />
          </label>
          <div className={styles['property-input']}>
            <SelectPropertyDropdown
              id='page-mode'
              options={pageModeItems}
              property='displayMode'
              updateWidget={(update) => updatePage({ data: { ...page.data, ...update } })}
              widget={page.data}
            />
          </div>
        </div>
      </div>
    </section>
  );
};
